export const PLATFORM_CLOSED_KEY = "platform_closed";
export const PLATFORM_LOCK_PASSWORD_HASH_KEY = "platform_lock_password_hash";
export const PLATFORM_LOCK_PASSWORD_INPUT_KEY = "platform_lock_password";
export const PLATFORM_LOCK_PASSWORD_CONFIGURED_KEY =
  "platform_lock_password_configured";
export const PLATFORM_LOCK_COOKIE_NAME = "platform_lock_unlocked";

const STATIC_FILE_RE = /\.[a-z0-9]{1,12}$/i;

export function isPlatformLockProtectedPath(pathname: string): boolean {
  if (!pathname || !pathname.startsWith("/")) return false;
  if (pathname.startsWith("/api/") || pathname === "/api") return false;
  if (pathname.startsWith("/dashboard")) return false;
  if (pathname === "/login" || pathname === "/post-login") return false;
  if (pathname.startsWith("/uploads/")) return false;
  if (pathname.startsWith("/assets/")) return false;
  if (pathname.startsWith("/_bun/")) return false;
  if (pathname === "/favicon.ico" || pathname === "/robots.txt") return false;
  if (pathname === "/sitemap.xml") return false;
  return !STATIC_FILE_RE.test(pathname);
}
